<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['delete']);

const { t } = useI18n();

const dialogRef = ref(null);
const currentPolicyId = ref(null);
const currentPolicyName = ref('');

const description = computed(() =>
  currentPolicyName.value
    ? t('ASSIGNMENT_POLICY.REDESIGN.COMMON.DELETE_DESCRIPTION', {
        name: currentPolicyName.value,
      })
    : t('ASSIGNMENT_POLICY.DELETE_POLICY.DESCRIPTION')
);

const openDialog = (policyId, policyName = '') => {
  currentPolicyId.value = policyId;
  currentPolicyName.value = policyName || '';
  dialogRef.value.open();
};

const closeDialog = () => {
  dialogRef.value.close();
};

const handleDialogConfirm = () => {
  emit('delete', currentPolicyId.value);
};

defineExpose({ openDialog, closeDialog });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('ASSIGNMENT_POLICY.DELETE_POLICY.TITLE')"
    :description="description"
    :confirm-button-label="
      t('ASSIGNMENT_POLICY.DELETE_POLICY.CONFIRM_BUTTON_LABEL')
    "
    :cancel-button-label="
      t('ASSIGNMENT_POLICY.DELETE_POLICY.CANCEL_BUTTON_LABEL')
    "
    @confirm="handleDialogConfirm"
  />
</template>
